import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.checkliste-aktualisieren';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenChecklisteAktualisierenEffects {

    ChecklisteAktualisieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_CHECKLISTE_AKTUALISIEREN),
        mergeMap((x: ac.PostChecklisteAktualisierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postChecklisteAktualisieren(x.checklisteModelRequest).pipe(
                map((result: any) => {
                    return new ac.PostChecklisteAktualisierenErfolgreichAction(result, x.checklisteModelRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostChecklisteAktualisierenFehlerAction(error, x.checklisteModelRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ChecklisteCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ChecklisteCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.ChecklisteCommandService);
        }
        return this.service;
    }
}
